// extracted by mini-css-extract-plugin
module.exports = {"inline-param":"_93444fe79c--inline-param--qdYWd","inline-label":"_93444fe79c--inline-label--YwfRV"};